var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGavel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2094_3389)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.5 15.7499H9C9.4125 15.7499 9.75 16.0874 9.75 16.4999C9.75 16.9124 9.4125 17.2499 9 17.2499H1.5C1.0875 17.2499 0.75 16.9124 0.75 16.4999C0.75 16.0874 1.0875 15.7499 1.5 15.7499ZM3.93 6.05245L6.0525 3.92995L15.6 13.4774C16.185 14.0624 16.185 15.0149 15.6 15.5999C15.015 16.1849 14.0625 16.1849 13.4775 15.5999L3.93 6.05245ZM10.2975 1.80745L12.42 3.92995C13.005 4.51495 13.005 5.46745 12.42 6.05245L11.355 7.11745L7.1175 2.87245L8.175 1.81495C8.76 1.22245 9.7125 1.22245 10.2975 1.80745ZM2.8725 7.10995L7.1175 11.3549L6.06 12.4124C5.475 12.9974 4.5225 12.9974 3.9375 12.4124L1.815 10.2899C1.23 9.70495 1.23 8.75245 1.815 8.16745L2.8725 7.10995Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2094_3389"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGavel);
export default __webpack_public_path__ + "static/media/Gavel.d716ee29cb2e4d0e45535305c3a71219.svg";
export { ForwardRef as ReactComponent };